import axios from 'axios';

const getDefault = () => axios.get('/comprador/default');

export default {
  getDefault,
};
